import { getProductBundledInfo, shopifyCartAdd } from '@utils/api.js'

document.addEventListener('DOMContentLoaded', function () {
  if(!customElements.get('jky-v5-app-bundled-sale')) {
    customElements.define('jky-v5-app-bundled-sale', class JkyV5AppBundledSale extends HTMLElement {
      constructor() {
        super();
        const { productTitle, variantId, variantTitle, isDiy } = this.dataset
        
        this.productTitle = productTitle
        this.variantId = variantId
        this.variantTitle = variantTitle
        this.isDiy = isDiy === 'true'

        // 分页
        this.pageNum = 1
        this.pageSize = 5
        this.total = 0

        // 接口请求中
        this.loading = false

        this._bundleGoodsList = []

        this.init()

        // 新 main-product 触发variant变化 - 改变当前变体
        if (document.querySelector('variant-fields')) {
          document.addEventListener('variantChangeEvent', e => {
            const currentVariant = e.detail.variant
            if (currentVariant) {
              this.variantId = currentVariant.id
              this.variantTitle = currentVariant.title

              // 重置 pageNum
              this.pageNum = 1
              setTimeout(() => this.init(), 200)
            }
          })
        }
      }

      async init() {
        try {
          this.loading = true
          const { data } = await getProductBundledInfo({ skuId: this.variantId, page: this.pageNum, limit: this.pageSize, })
          if (data?.total > 0) {
            const { title, bundleGoodsList, total, } = data
            this.total = total
            this._bundleGoodsList = [...bundleGoodsList, ...this._bundleGoodsList]

            this.innerHTML = this.renderDOM(title)
            this.parentElement.style.display = 'block'

            this.ulDOM = this.querySelector('ul')
            const bundleList = this.renderBundleList(bundleGoodsList)
            this.ulDOM.insertAdjacentHTML('beforeend', bundleList)

            // 初始化 交互事件
            this.initEvent()

            // 监听滚动事件
            this.watchScroll = this.watchScroll.bind(this)
            this.ulDOM.removeEventListener('scroll', this.watchScroll)
            this.ulDOM.addEventListener('scroll', this.watchScroll)


            const event_variant_change = new CustomEvent('bundleLoadedEvent', {
              detail: {
                list: bundleGoodsList
              }
            })
            document.dispatchEvent(event_variant_change)


            this.diyEvent(bundleGoodsList, true);
          } else {
            // 清空DOM
            this.innerHTML = ''
            this.parentElement.style.display = 'none'

            const event_variant_change = new CustomEvent('bundleLoadedEvent', {
              detail: {
                list: []
              }
            })
            document.dispatchEvent(event_variant_change)
          }
        } catch(err) {
          // 清空DOM
          this.innerHTML = ''
          this.parentElement.style.display = 'none'
        } finally {
          this.loading = false
        }
      }
      // diy event
      diyEvent(bundleGoodsList = [], init = false) {
        if(this.isDiy) {
          console.log("bundleGoodsList---", bundleGoodsList)
          try {
            const list = init ? bundleGoodsList.filter(item => item.defaultChosen === 1) : bundleGoodsList;
            console.log("list---", list)
            list.forEach(item => {
              item.quantity = item._quantity ? item._quantity : item.quantity ? item.quantity : 0;
              if(item.remove) {
                item.quantity = 0;
              }
              const event = new CustomEvent('diyBundleChangeEvent', {
                detail: {
                  variant: item
                }
              })
              document.dispatchEvent(event)
            })
          } catch (error) {
            console.warn("bundleGoodsList error:", error)
          }
        }
      }
      watchScroll() {
        if (this.isScrollAtBottom() && !this.loading) {
          if (Math.ceil(this.total / this.pageSize) <= this.pageNum) return

          // 加载数据
          this.loadData()
        }
      }
      async loadData() {
        try {
          this.pageNum++
          this.loading = true
          const { data: { bundleGoodsList, } } = await getProductBundledInfo({
            skuId: this.variantId,
            page: this.pageNum,
            limit: this.pageSize,
          })
          this._bundleGoodsList = [...this._bundleGoodsList, ...bundleGoodsList];
          this.ulDOM.insertAdjacentHTML('beforeend', this.renderBundleList(bundleGoodsList))
          

          // 初始化 交互事件
          this.initEvent()

          const event_variant_change = new CustomEvent('bundleLoadedEvent', {
            detail: {
              list: bundleGoodsList
            }
          })
          document.dispatchEvent(event_variant_change);

          this.diyEvent(bundleGoodsList, true);
        } catch(err) {
          console.log(err)
        } finally {
          this.loading = false
        }
      }
      // 初始化 交互事件
      initEvent() {
        if (this.isDiy) {
          const _this = this;
          this.ulDOM.querySelectorAll('label').forEach(item => {
            const checkbox = item.querySelector('input[type="checkbox"]')
            
            // 处理 checkbox change 事件
            function handleChangeBox(e) {
              e.preventDefault()
              const inputWrapPC = item.querySelector('[data-quantity-input-wrap-pc]')
              const inputWrapMB = item.querySelector('[data-quantity-input-wrap-mb]')

              if(e.target.checked) {
                item.classList.add('active')
                inputWrapPC.classList.remove('hidden')
                inputWrapPC.classList.add('lg:flex')
                inputWrapMB.classList.remove('hidden')
                inputWrapMB.classList.add('flex')
              } else {
                item.classList.remove('active')
                inputWrapPC.classList.add('hidden')
                inputWrapPC.classList.remove('lg:flex')
                inputWrapMB.classList.add('hidden')
                inputWrapMB.classList.remove('flex')

                item.querySelectorAll('[data-quantity-input]').forEach(it => it.value = 1)
              }

              try {
                console.log("debug---checkbox---", checkbox.getAttribute('skuid'), _this._bundleGoodsList)
                const active_item_bundle = _this._bundleGoodsList.find(b => Number(b.skuId) === Number(checkbox.getAttribute('skuid')))

                if(e.target.checked) {
                  const numberInput = item.querySelector('input[type="input"]')
                  if(numberInput) {
                    console.log("debug---active_item_bundle---", active_item_bundle, numberInput, numberInput?.value)
                    active_item_bundle.quantity = Number(numberInput.value) || 1;
                    active_item_bundle.remove = false;
                  }
                } else {
                  if(active_item_bundle) {
                    active_item_bundle.defaultChosen = 0;
                    active_item_bundle.remove = true;
                  }
                }

                console.log("active_item_bundle---", active_item_bundle)
                _this.diyEvent([active_item_bundle]);
              } catch (error) {
                console.warn("diyBundleChangeEvent error:", error)
                
              }
            }
            checkbox.removeEventListener('change', handleChangeBox)
            // 避免重复注册 click 事件
            if (!checkbox.dataset.hasEvent) {
              checkbox.addEventListener('change', handleChangeBox)
              checkbox.dataset.hasEvent = true
            }

            // 初始化 quantity-input 交互事件
            this.initQuantityEvent(item)
          })
        } else {
          this.ulDOM.querySelectorAll('li').forEach(item => {
            // 初始化 quantity-input 交互事件
            this.initQuantityEvent(item)
          })

          // 监听 加购button 点击事件
          this.querySelectorAll('[data-add-to-cart-btn]').forEach(button => {
            button.addEventListener('click', async (e) => {
              const target = e.currentTarget
              // loading
              target.classList.add('loading')
  
              const skuId = target.getAttribute('data-sku-id')
  
              const parentElement = button.closest('[data-action-wrap]')
  
              // 触发添加到购物车的事件
              const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
              const quantity = parentElement.querySelector('[data-quantity-input]').value
              try {
                const data = await shopifyCartAdd({ items: [{ id: Number(skuId), quantity, properties: { Action: 'bundled sale' } }] })
                if(cart) {
                  cart.renderContents(data)
                } else {
                  window.location.href = '/cart'
                }
              } catch(err) {
                console.log(err)
              } finally {
                // 移除loading
                target.classList.remove('loading')
  
                // 数据埋码
                gaPushDataLayer('5.0_products_details_page_user_clicks', {
                  product_spu_name: this.productTitle, // 识别页面产品spu标题名称text
                  module: "Product Selection Adds",// 固定模块命名Product Selection Adds
                  position: this.variantTitle, // 选择的主体产品sku文本text
                  button_name: "AddToCart", // 固定为AddToCart
                  quantity: quantity, //识别主体产品加购数量
                })
              }
            })
          })
        }
      }
      // 初始化 quantity-input 交互事件
      initQuantityEvent(item) {
        const _this = this
        const minusBtns = item.querySelectorAll('[data-button-minus]')
        const quantityInputs = item.querySelectorAll('[data-quantity-input]')
        const plusBtns = item.querySelectorAll('[data-button-plus]')

        function handleMinus(e) {
          e.preventDefault()
          const target = e.currentTarget

          quantityInputs.forEach(it => {
            plusBtns.forEach(m => m.removeAttribute('disabled'))
            it.value = it.value * 1 > 1 ? it.value * 1 - 1 : 1

            if (it.value == 1) {
              target.setAttribute('disabled', 'disabled')
            }

            try {
              if(_this.isDiy) {
                const numberInput = item.querySelector('input[type="number"]');
                const active_item_bundle = _this._bundleGoodsList.find(b => Number(b.skuId) === Number(it.getAttribute('data-sku-id')));
    
                console.log("_this._bundleGoodsList---", _this._bundleGoodsList, active_item_bundle, numberInput, it)
                if(active_item_bundle) {
                  active_item_bundle.quantity = Number(it.value) || 1;
                  active_item_bundle._quantity = Number(it.value) || 1;
                  console.log("active_item_bundle===minus", active_item_bundle)
                  _this.diyEvent([active_item_bundle]);
                }
              }
            } catch (error) {
              console.warn("initQuantityEvent error:", error)
            }
          })
        }
        function handlePlus(e) {
          e.preventDefault()
          const target = e.currentTarget

          quantityInputs.forEach(it => {
            minusBtns.forEach(m => m.removeAttribute('disabled'))
            it.value = it.value * 1 < Number(it.dataset.max) ? it.value * 1 + 1 : Number(it.dataset.max)

            if (it.value == Number(it.dataset.max)) {
              target.setAttribute('disabled', 'disabled')
            }

            try {
              if(_this.isDiy) {
                const numberInput = item.querySelector('input[type="number"]');
                const active_item_bundle = _this._bundleGoodsList.find(b => Number(b.skuId) === Number(it.getAttribute('data-sku-id')));
    
                console.log("_this._bundleGoodsList---", item, _this._bundleGoodsList, active_item_bundle, numberInput, numberInput?.value, it, it?.value)
                if(active_item_bundle) {
                  active_item_bundle.quantity = Number(it.value) || 1;
                  active_item_bundle._quantity = Number(it.value) || 1;
                  console.log("active_item_bundle===", active_item_bundle)
                  _this.diyEvent([active_item_bundle]);
                }
              }
            } catch (error) {
              console.warn("initQuantityEvent error:", error)
            }
          })
        }

        minusBtns.forEach(it => {
          it.removeEventListener('click', handleMinus)
          // 避免重复注册 click 事件
          if (!it.dataset.hasEvent) {
            it.addEventListener('click', handleMinus)
            it.dataset.hasEvent = true
          }
        })

        plusBtns.forEach(it => {
          it.removeEventListener('click', handlePlus)
          // 避免重复注册 click 事件
          if (!it.dataset.hasEvent) {
            it.addEventListener('click', handlePlus)
            it.dataset.hasEvent = true
          }
        })
      }
      renderDOM(title) {
        return `
          <div class="font-semibold text-[#242F20] text-xl lg:text-2xl" data-app-bundled-sale-title>${title}</div>
          <ul class="flex flex-col max-h-[16.875rem] gap-y-4 pr-1 overflow-y-auto lg:max-h-[23.3125rem] lg:pr-2.5"></ul>
        `
      }
      renderBundleList(list) {
        let html = ''
        if (this.isDiy) {
          list.forEach(({ skuId, title, price, originPrice, positioningDesc, positioningDescColor, positioningTag, image, stock, defaultChosen}, index) => {
            const formatPrice = formatMoney(price * 100, window?.pageInfo?.currency?.money_format)
            const quantityInputHTML = this.renderQuantityInput(stock, skuId, title, formatPrice)
            html += `
              <label skuId="${skuId}" for="add-on-${skuId + '--' + index}" class="w-full flex shrink-0 items-start lg:items-center flex-row border-solid border-[#C6C7C8] gap-x-3 border-[1px] min-h-[6.375rem] lg:gap-x-4 px-2.5 pb-5 lg:px-4 lg:pb-6 ${positioningTag ? 'pt-10 lg:pt-10' : 'pt-5 lg:pt-6'} lg:min-h-[7.5rem] cursor-pointer relative ${defaultChosen === 1 ? 'active' : ''}">
                ${positioningTag
                  ? `<span class="absolute right-[-1px] top-[-1px] bg-[#242F20] text-white font-semibold text-[0.75rem] lg:text-[1rem] leading-[1.75rem] h-7 px-2 lg:px-3">${positioningTag}</span>`
                  : ''
                }
                <div class="flex items-center gap-x-2.5 lg:gap-x-4">
                  <input skuId="${skuId}" type="checkbox" id="add-on-${skuId + '--' + index}" title="${title}" price="${formatPrice}" class="w-4 h-4 lg:w-5 lg:h-5" ${defaultChosen === 1 ? 'checked' : ''}>
                  <img class="w-12 h-12 lg:w-[4.5rem] lg:h-[4.5rem] object-contain" src="${image.split('?')[0]}?width=144" alt="${title}" loading="lazy">
                </div>
                <div class="flex flex-col flex-1">
                  <h4 class="text-[#242F20] font-semibold text-sm lg:text-xl">${title}</h4>
                  <p class="flex flex-row items-center lg:hidden mt-2">
                    <em class="text-[#242F20] font-semibold not-italic text-base lg:text-xl">${formatPrice}</em>
                    ${originPrice > price
                      ? `<span class="text-[#999999] font-normal text-xs ml-2 line-through lg:text-base">${formatMoney(originPrice * 100, window?.pageInfo?.currency?.money_format)}</span>`
                      : ''
                    }
                  </p>
                  ${positioningDesc
                    ? `<p class="text-[#999999] font-semibold mt-3 lg:mt-0 text-xs lg:text-base" style="color:${positioningDescColor}">${positioningDesc}</p>`
                    : ''
                  }
                  <div class="w-full lg:hidden ${defaultChosen === 1 ? 'flex' : 'hidden'} justify-end mt-3 lg:mt-1" data-quantity-input-wrap-mb>
                    ${quantityInputHTML}
                  </div>
                </div>
                <div class="hidden lg:flex flex-col items-end lg:gap-y-1 lg:min-w-[6.875rem]">
                  <em class="text-[#242F20] font-semibold not-italic lg:text-xl">${formatMoney(price * 100, window?.pageInfo?.currency?.money_format)}</em>
                  ${originPrice > price
                    ? `<span class="text-[#999999] font-normal line-through lg:text-base">${formatMoney(originPrice * 100, window?.pageInfo?.currency?.money_format)}</span>`
                    : ''
                  }

                  <div class="mt-3 lg:mt-1 hidden ${defaultChosen === 1 ? 'lg:flex' : ''}" data-quantity-input-wrap-pc>
                    ${quantityInputHTML}
                  </div>
                </div>
              </label>
            `
          })
        } else {
          list.forEach(({ skuId, title, price, originPrice, positioningDesc, positioningDescColor, image, stock, }, index) => {
            const formatPrice = formatMoney(price * 100, window?.pageInfo?.currency?.money_format)
            const quantityInputHTML = this.renderQuantityInput(stock, skuId, title, formatPrice)
            html += `
              <li class="w-full flex shrink-0 items-start lg:items-center flex-row border-0 border-solid border-b-[1px] border-[#E2E3E3] pb-4 gap-x-2 lg:gap-x-4">
                <script type="application/json" id="BundleList-${index}">${JSON.stringify(list[index])}</script>
                <img class="w-[4.5rem] h-[4.5rem] lg:w-24 lg:h-24 object-contain" src="${image}" alt="" loading="lazy">
                <div class="flex flex-col justify-between min-h-[4.5rem] lg:min-h-24 flex-1">
                  <h4 class="w-full text-[#242F20] font-semibold text-sm lg:text-xl line-clamp-2" title="${title}">${title}</h4>
                  ${positioningDesc
                    ? `<p class="text-[#999999] mt-2 text-xs lg:text-sm" style="color:${positioningDescColor}">${positioningDesc}</p>`
                    : ''
                  }
                  <div class="flex items-center justify-between mt-2 lg:mt-3">
                    <p class="flex items-center gap-x-1">
                      <em class="text-[#242F20] font-semibold not-italic text-base lg:text-xl">${formatPrice}</em>
                      ${originPrice > price
                        ? `<span class="text-[#242F20]/65 text-xs lg:text-sm line-through">${formatMoney(originPrice * 100, window?.pageInfo?.currency?.money_format)}</span>`
                        : ''
                      }
                    </p>
                    <div class="flex items-center gap-x-2 lg:gap-x-4" data-action-wrap>
                      ${quantityInputHTML}
                      <button class="jky-v5-button appearance-none bg-primary flex items-center justify-center w-7 h-7 lg:w-8 lg:h-8" data-sku-id="${skuId}" data-add-to-cart-btn>
                        <svg class="text-white w-7 h-7 lg:w-8 lg:h-8" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.71484 8.00781H9.65015L11.2313 27.1924H29.5727L34.6183 12.2102H14.3796" stroke="currentColor" stroke-width="2" stroke-linejoin="bevel"/>
                          <path d="M17.0781 18.9531H26.0731" stroke="currentColor" stroke-width="2"/>
                          <path d="M21.5742 23.4453V14.4503" stroke="currentColor" stroke-width="2"/>
                          <path d="M16.5056 30.8516C16.5056 31.9383 15.6247 32.8192 14.538 32.8192C13.4513 32.8192 12.5703 31.9383 12.5703 30.8516" stroke="currentColor" stroke-width="2"/>
                          <path d="M28.2009 30.8516C28.2009 31.9383 27.32 32.8192 26.2333 32.8192C25.1466 32.8192 24.2656 31.9383 24.2656 30.8516" stroke="currentColor" stroke-width="2"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </li>
            `
          })
        }

        return html
      }
      // 检查是否滚动到底部
      isScrollAtBottom() {
        return this.ulDOM.scrollHeight - this.ulDOM.scrollTop <= this.ulDOM.clientHeight + 50;
      }
      // 渲染 quantity-input
      renderQuantityInput(stock, skuId, title, price) {
        return `
          <div class="flex border-solid border-[#E2E3E3] border-[1px]">
            <button
              class="appearance-none bg-[#F5F5F5] flex-center w-7 h-7 lg:w-8 lg:h-8 disabled:opacity-40 disabled:cursor-not-allowed"
              disabled
              data-button-minus
              data-sku-title="${title}"
              data-sku-price="${price}"
            >
              ${this.renderMinusSVG()}
            </button>
            <input
              class="flex-center font-semibold text-center border-0 border-solid border-[#E2E3E3] border-x-[1px] w-8 h-7 lg:w-11 lg:h-8 text-base lg:text-xl"
              type="number"
              value="1"
              readonly
              data-quantity-input
              data-max="${stock}"
              data-sku-id="${skuId}"
              data-sku-title="${title}"
              data-sku-price="${price}"
            />
            <button
              class="appearance-none bg-[#F5F5F5] flex-center w-7 h-7 lg:w-8 lg:h-8 disabled:opacity-40 disabled:cursor-not-allowed"
              data-button-plus
              data-sku-title="${title}"
              data-sku-price="${price}"
            >
              ${this.renderPlusSVG()}
            </button>
          </div>
        `
      }
      renderMinusSVG() {
        return `
          <svg class="text-[#242F20] w-3.5 h-3.5" viewBox="0 0 56 56" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g transform="translate(-1053.000000, -594.000000)">
                <g transform="translate(1053.000000, 594.000000)">
                  <rect x="0" y="0" width="56" height="56"></rect>
                  <g transform="translate(7.000000, 26.000000)" fill="#333" fill-rule="nonzero">
                    <path d="M2.24098777,4.36809816 L39.3054147,4.36809816 C39.7082889,4.36809816 40.0817869,4.27048703 40.4259086,4.07526476 C40.7700303,3.8800425 41.0428097,3.61567902 41.2442468,3.28217432 C41.445684,2.94866961 41.5464025,2.57856074 41.5464025,2.17184769 C41.5464025,1.78140316 41.445684,1.41942855 41.2442468,1.08592384 C41.0428097,0.752419143 40.7700303,0.48805566 40.4259086,0.292833396 C40.0817869,0.0976111321 39.7082889,0 39.3054147,0 L2.24098777,0 C1.83811357,0 1.46881221,0.0976111321 1.1330837,0.292833396 C0.7973552,0.48805566 0.524575789,0.752419143 0.314745474,1.08592384 C0.104915158,1.41942855 0,1.78140316 0,2.17184769 C0,2.57856074 0.104915158,2.94866961 0.314745474,3.28217432 C0.524575789,3.61567902 0.7973552,3.8800425 1.1330837,4.07526476 C1.46881221,4.27048703 1.83811357,4.36809816 2.24098777,4.36809816 Z" id="路径"></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        `
      }
      renderPlusSVG() {
        return `
          <svg class="text-[#242F20] w-3.5 h-3.5" viewBox="0 0 56 56" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g transform="translate(-931.000000, -594.000000)">
                <g transform="translate(931.000000, 594.000000)">
                  <rect x="0" y="0" width="56" height="56"></rect>
                  <g transform="translate(7.000000, 7.000000)" fill="#333" fill-rule="nonzero">
                    <path d="M0,20.7484663 C0,21.3688244 0.222420135,21.8969672 0.667260404,22.3328946 C1.11210067,22.768822 1.63667646,22.9867856 2.24098777,22.9867856 L18.5322135,22.9867856 L18.5322135,39.2586131 C18.5322135,39.8622049 18.750437,40.386156 19.1868841,40.8304666 C19.6233311,41.2747772 20.1521035,41.4969325 20.7732013,41.4969325 C21.394299,41.4969325 21.927268,41.2747772 22.3721083,40.8304666 C22.8169485,40.386156 23.0393687,39.8622049 23.0393687,39.2586131 L23.0393687,22.9867856 L39.3054147,22.9867856 C39.909726,22.9867856 40.4343018,22.768822 40.8791421,22.3328946 C41.3239824,21.8969672 41.5464025,21.3688244 41.5464025,20.7484663 C41.5464025,20.1281081 41.3239824,19.5957737 40.8791421,19.1514631 C40.4343018,18.7071525 39.909726,18.4849972 39.3054147,18.4849972 L23.0393687,18.4849972 L23.0393687,2.23831939 C23.0393687,1.63472764 22.8169485,1.11077648 22.3721083,0.666465886 C21.927268,0.222155295 21.394299,0 20.7732013,0 C20.1521035,0 19.6233311,0.222155295 19.1868841,0.666465886 C18.750437,1.11077648 18.5322135,1.63472764 18.5322135,2.23831939 L18.5322135,18.4849972 L2.24098777,18.4849972 C1.63667646,18.4849972 1.11210067,18.7071525 0.667260404,19.1514631 C0.222420135,19.5957737 0,20.1281081 0,20.7484663 Z" id="路径"></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        `
      }
    })
  }
})
